export default __webpack_public_path__ + "static/media/windspeed.fa0ae646.svg";